import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
// import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'mat-star-rating',
  templateUrl: './star-ratting.component.html',
  styles: [''],
  encapsulation: ViewEncapsulation.Emulated
})
export class StarRatingComponent implements OnInit {


  @Input('rating') public rating = 3;
  @Input('starCount') public starCount = 5;
  @Input('color') public color = 'primary';
  @Output() public ratingUpdated = new EventEmitter();

  public snackBarDuration = 2000;
  public ratingArr = [];

  constructor(
    // public snackBar: MatSnackBar

    ) {
  }


  ngOnInit() {
    console.log('a ' + this.starCount);
    for (let index = 0; index < this.starCount; index++) {
      this.ratingArr.push(index);
    }
  }
  onClick(rating: number) {
    console.log('Rating of', rating);
    // this.snackBar.open('You rated ' + rating + ' / ' + this.starCount, '', {
    //   duration: this.snackBarDuration
    // });
    this.ratingUpdated.emit(rating);
    return false;
  }

  showIcon(index: number) {
    if (this.rating >= index + 1) {
      return 'star';
    } else {
      return 'star_border';
    }
  }

  showToolTip(index: number) {
    switch (index + 1) {
      case 1:
        return 'Very Poor';
      case 2:
        return 'Poor';
      case 3:
        return 'Average';
      case 4:
        return 'Good';
      case 5:
        return 'Very Good';
    }
  }

}
export enum StarRatingColor {
  primary = 'primary',
  accent = 'accent',
  warn = 'warn'
}


